import * as React from 'react';
import { Component, deps, inject, observer } from '../lib/component';
import { AccountLayout } from '../components/account/layout';
import { Loading } from '../components/loading/loading';
import { centerCenter } from 'csstips';
import { px } from 'csx';
import { style } from 'typestyle';
import {PageAccountLinkedAccounts} from '../components/page-account-linked-accounts';

export interface AccountPageProps {

}

@inject(deps) @observer
export class AccountPage extends Component<AccountPageProps> {
  render() {
    if (this.props.model.ui.isServer) return <div />;

    const model = this.props.model.page.account;

    if (model.loading || this.props.model.user.loadingAccounts) return (
      <AccountLayout>
        <div className={style({ padding: px(80), ...centerCenter })}>
          <Loading />
        </div>
      </AccountLayout>
    );

    const { user } = this.props.controller;

    return (
      <AccountLayout>
        <PageAccountLinkedAccounts
          model={this.props.model.user}
          onLinkTwitter={this.handleLinkTwitter}
          onUnlinkSpotify={user.unlinkSpotify}
          onUnlinkTwitter={user.unlinkTwitter}
          onUnlinkDropbox={user.unlinkDropbox}
          onUnlinkFacebook={user.unlinkFacebook}
          i18n={model.i18n}
        />
      </AccountLayout>
    )
  }

  handleLinkTwitter = (event: React.MouseEvent<any>) => {
    event.preventDefault();
    this.props.controller.onboarding.openTwitterModal();
  }
}